import InputKey from "./InputKey";

export default InputKey;
